import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import './inactivity-modal.scss';

function InactivityModal(props) {
  var show        = props.show;
  var secondsLeft = props.secondsLeft;
  var onStay      = props.onStay;
  var onLogout    = props.onLogout;
  var onRelogin   = props.onRelogin;
  var isKeycloak  = props.isKeycloak;          // Keycloak/Google user → re-auth via SSO, not password
  var onKeycloakRelogin = props.onKeycloakRelogin;

  var [reloginMode, setReloginMode] = useState(false);
  var [password,    setPassword]    = useState('');
  var [error,       setError]       = useState('');
  var [loading,     setLoading]     = useState(false);

  // Reset form when modal closes
  useEffect(function() {
    if (!show) {
      setReloginMode(false);
      setPassword('');
      setError('');
      setLoading(false);
    }
  }, [show]);

  var storedUsername = '';
  try {
    storedUsername = JSON.parse(localStorage.getItem('user') || '{}').username || '';
  } catch (_) {}

  function handleStayClick() {
    // Keycloak/Google: no app password — refresh the session silently and stay on this page.
    // The parent dismisses the modal on success, or redirects to Keycloak if refresh failed.
    if (isKeycloak) {
      if (!onKeycloakRelogin) return;
      setLoading(true);
      setError('');
      Promise.resolve(onKeycloakRelogin())
        .then(function() { setLoading(false); })
        .catch(function() { setLoading(false); });
      return;
    }
    setReloginMode(true);
    setPassword('');
    setError('');
  }

  function handleConfirm() {
    if (!password.trim()) { setError('Please enter your password.'); return; }
    setLoading(true);
    setError('');
    onRelogin(password)
      .then(function() {
        setLoading(false);
        onStay();
      })
      .catch(function() {
        setLoading(false);
        setError('Incorrect password. Please try again.');
      });
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') handleConfirm();
  }

  return (
    <Modal
      show={show}
      centered
      backdrop="static"
      className="inactivity-modal"
      backdropClassName="inactivity-backdrop"
      style={{ zIndex: 10000 }}
      enforceFocus={false}
    >
      <Modal.Body className="inactivity-modal-body">
        <div className="inactivity-icon">
          <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="11" stroke="#f59e0b" strokeWidth="2" />
            <path d="M12 7v5l3 3" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        {!reloginMode ? (
          <React.Fragment>
            <div className="inactivity-title">Session Idle</div>
            <div className="inactivity-message">
              You will be automatically logged out in{' '}
              <span className="inactivity-countdown">{secondsLeft}</span>{' '}
              second{secondsLeft !== 1 ? 's' : ''} due to inactivity.
            </div>
            <div className="inactivity-actions">
              <button className="inactivity-stay-btn" onClick={handleStayClick} disabled={loading}>
                {loading ? 'Reconnecting…' : 'Stay Logged In'}
              </button>
              <button className="inactivity-logout-btn" onClick={onLogout} disabled={loading}>
                Log Out Now
              </button>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="inactivity-title">Confirm Your Identity</div>
            <div className="inactivity-message">
              Re-enter your password to continue your session.
            </div>
            <div className="inactivity-relogin-form">
              <input
                className="inactivity-relogin-input inactivity-relogin-username"
                type="text"
                value={storedUsername}
                readOnly
                tabIndex={-1}
              />
              <input
                className="inactivity-relogin-input"
                type="password"
                placeholder="Password"
                value={password}
                onChange={function(e) { setPassword(e.target.value); setError(''); }}
                onKeyDown={handleKeyDown}
                autoFocus
                disabled={loading}
              />
              {error && <div className="inactivity-error">{error}</div>}
              <button
                className="inactivity-stay-btn"
                onClick={handleConfirm}
                disabled={loading}
                style={{ marginTop: 4 }}
              >
                {loading ? 'Verifying…' : 'Confirm & Stay'}
              </button>
              <button className="inactivity-logout-link" onClick={onLogout}>
                Log out instead
              </button>
            </div>
          </React.Fragment>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default InactivityModal;
